import { render, staticRenderFns } from "./ebooks-card.vue?vue&type=template&id=20aa71ce&scoped=true"
import script from "./ebooks-card.vue?vue&type=script&lang=js"
export * from "./ebooks-card.vue?vue&type=script&lang=js"
import style0 from "./ebooks-card.vue?vue&type=style&index=0&id=20aa71ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa71ce",
  null
  
)

export default component.exports